import {
  collection,
  getDocs,
  where,
  query,
  orderBy,
  limit,
} from "firebase/firestore";
import { db } from "@/firebase/index.js";
import { usePetAdsMapStore } from "@/stores/petAdsMapStore";

export const useGetPetAds = () => {
  const store = usePetAdsMapStore();

  const fetchPetAds = async () => {
    store.loading = true;
    const ads = [];

    try {
      const petQuery = query(
        collection(db, "pets"),
        where("status", "==", "active"),
        orderBy("createdAt", "desc"),
        limit(100)
      );

      const querySnapshot = await getDocs(petQuery);

      querySnapshot.forEach((doc) => {
        const adData = doc.data();
        if (adData.adLocation?._lat && adData.adLocation?._long) {
          ads.push({ id: doc.id, ...adData });
        } else {
          // console.log(
          //   `İlan ID ${doc.id}: Lokasyon bilgisi eksik, haritada gösterilmeyecek.`
          // );
        }
      });

      store.setPetAds(ads);
    } catch (err) {
      store.error = err.message;
      //console.error("Error fetching pet ads:", err);
    } finally {
      store.loading = false;
      //console.log(`${ads.length} adet lokasyonlu ilan yüklendi.`);
    }
  };

  return {
    petAdsMap: store.petAdsMap,
    error: store.error,
    loading: store.loading,
    fetchPetAds,
  };
};
